<template>
  <div class="card rounded p-4">
    <h1 class="title ml-4 pl-2 ">{{ $t("asset-group.degree-of-criticality") }}</h1>

    <right-panel class="float-right" id="sidebar-edit-asset-group-criticality" width="850px" @hidden="rightPanelClosed">
      <div class="pl-5 pr-5">
        <Form :hide-library="true" />
      </div>
    </right-panel>

    <div class="table-responsive pr-4 pt-2 ml-4">
      <div class="text-right">
        <b-dropdown split split-href="#" :text="$t('task.download-options')" size="sm" variant="light" class="mr-4 text-right mb-2 ">
          <b-dropdown-item @click="downloadExcel" href="#">{{ $t("common.download") }}</b-dropdown-item>
        </b-dropdown>
      </div>
      <table>
        <thead>
          <tr>
            <th>{{ $t("asset-group-category.text") }}</th>
            <th>{{ $t("asset-group.no") }}</th>
            <th>{{ $t("asset-group.name") }}</th>

            <th>{{ $t("asset-group-survey.assesment-criterias.privacy") }}</th>
            <th>{{ $t("asset-group-survey.assesment-criterias.entirety") }}</th>
            <th>{{ $t("asset-group-survey.assesment-criterias.accessibility") }}</th>
            <th>{{ $t("asset-group.degree-of-criticality") }}</th>
            <th>{{ $t("asset-group.description") }}</th>
            <th>{{ $t("asset-group.last-edit-date") }}</th>
            <th>{{ $t("asset-group.last-edited-person") }}</th>
            <th>
              <a href="javascript:;" @click="toggleFilter">
                <span v-if="filterEnabled" class="text-warning">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-hide") }}
                </span>
                <span v-else class="text-muted">
                  <i class="bx bxs-filter-alt"></i>
                  {{ $t("common.filters-show") }}
                </span>
              </a>
            </th>
          </tr>
          <tr v-if="filterEnabled">
            <th>
              <filter-select
                id="assetGroupCategoryFilter"
                ref="assetGroupCategoryFilter"
                :placeholder="$t('asset-group-category.text')"
                :multiple="false"
                @filter="onAssetGroupCategorySearch"
                :selected="assetGroupCategoryFilter"
                @changed="onAssetGroupCategorySelect"
              />
            </th>
            <th><input :placeholder="$t('task.no-in-short')" class="form-control" v-model="noFilter" type="text" /></th>
            <th><input class="form-control " v-model="nameFilter" :placeholder="$t('common.search')" /></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="pagination && pagination.docs.length > 0">
          <tr v-for="item in pagination.docs" :key="item._id" class="hider">
            <td>
              <span v-if="item.assetGroupCategory">{{ item.assetGroupCategory.name | translate }}</span>
            </td>
            <td>
              <span>{{ item.no }}</span>
            </td>
            <td>
              <span>{{ item.name | translate }}</span>
            </td>

            <td>
              <span v-if="item.assesmentCriterias">{{ item.assesmentCriterias.privacy }}</span>
            </td>
            <td>
              <span v-if="item.assesmentCriterias">{{ item.assesmentCriterias.entirety }}</span>
            </td>
            <td>
              <span v-if="item.assesmentCriterias">{{ item.assesmentCriterias.accessibility }}</span>
            </td>

            <td>
              <span v-if="item.assetGroup">{{ item.criticalityLevel }}</span>
            </td>
            <td>
              <span>{{ item.description | translate }}</span>
            </td>
            <td>
              <span>{{ item.lastCriticalityEditDate | date }}</span>
            </td>
            <td>
              <span v-if="item.updatedBy && item.updatedBy.account">{{ item.updatedBy.account.name }}</span>
            </td>

            <td>
              <span v-b-tooltip.hover :title="$t('common.edit')" class="hand text-main mr-1" @click="edit(item)"> <i class="bx bx-pencil align-middle"></i></span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="11">
              <empty v-if="!pagination || pagination.docs.length == 0">
                <h5 class="text-center">
                  {{ $t("asset-group.empty") }}
                </h5>
              </empty>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="pagination" class="d-flex ">
        <template>
          <div class="d-flex justify-content-center my-3">
            <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="5" size="sm"></b-pagination>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SweetTextarea from "@c/form/sweet-textarea";
import { required } from "vuelidate/lib/validators";
import Form from "./bgys-asset-group-category-asset-group-criticality-form.vue";
export default {
  components: { SweetTextarea, Form },

  data() {
    return {
      assetGroupCount: undefined,
      assetGroupDescription: undefined,
      editedAssetGroup: undefined,
      criticalityLevelDetermination: false,

      filterEnabled: false,
      assetGroupCategoryFilter: undefined,
      noFilter: undefined,
      nameFilter: undefined,

      request: {
        options: { page: 1, limit: 15, sort: { assetGroupCategory: 1, no: 1 } },
        query: {}, //{ status: { value: "DONE", isObject: true } },
      },
    };
  },
  beforeDestroy() {},
  computed: {
    pagination() {
      return this.$store.getters[`organizationAssetGroup/pagination`];
    },
  },
  watch: {
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounceMixin(() => this.fetchAssetGroups());
      },
    },
    noFilter(n, o) {
      if (n) {
        const isNumber = !isNaN(n);
        if (!isNumber) {
          this.clearNoFilter();
        }
        this.request.query = { ...this.request.query, ...(isNumber ? { no: { value: n, isObject: true } } : {}) };
      } else {
        this.clearNoFilter();
      }
    },
    nameFilter(n, o) {
      if (n) {
        this.request.query = { ...this.request.query, name: { value: n } };
      } else {
        this.request.query["name"] = null;
        delete this.request.query["name"];
      }
    },
  },
  validations: {
    assetGroupDescription: {
      required,
    },
    assetGroupCount: {
      required,
    },
  },
  methods: {
    clearNoFilter() {
      this.request.query["no"] = null;
      delete this.request.query["no"];
    },
    toggleFilter() {
      this.filterEnabled = !this.filterEnabled;

      if (!this.filterEnabled) {
        this.request = {
          options: { page: 1, limit: 14, sort: { assetGroupCategory: 1, no: 1 } },
          query: {},
        };
        this.nameFilter = undefined;
        this.categoryFilter = undefined;
      }
    },
    async onAssetGroupCategorySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationAssetGroupCategory/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onAssetGroupCategorySelect(assetGroupCategory) {
      if (!assetGroupCategory) {
        this.request.query["assetGroupCategory"] = undefined;
        delete this.request.query["assetGroupCategory"];
        return;
      }
      this.request.query = {
        ...this.request.query,
        assetGroupCategory: { value: assetGroupCategory._id, isObject: true },
      };
    },

    rightPanelClosed() {
      // this.$store.commit(`${state}/editedEntity`, null);
      this.fetchAssetGroups();
    },

    edit(item) {
      this.$store.commit(`organizationAssetGroup/editedEntity`, { ...item });
      this.$root.$emit("bv::toggle::collapse", "sidebar-edit-asset-group-criticality");
    },
    redirectToSurvey(item) {
      this.$router.push(`/ddo/asset-group/${item.assetGroup}/survey/${item._id}/results`);
    },

    async fetchAssetGroups() {
      await this.$store.dispatch("organizationAssetGroup/paginate", this.request);
    },
    async downloadExcel() {
      try {
        const payload = { organization: { _id: this.currentOrganization?._id, name: this.currentOrganization?.name } };

        const { data: file } = await this.$store.dispatch(`organizationAssetGroup/download`, payload);
        this.download(file);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async download(item) {
      this.$store.commit("fileManager/addDownloadedFile", { file: item });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../task/tasks.scss");

tr td {
  text-align: center;
}
</style>
